import { render, staticRenderFns } from "./payment-page-additional-travellers.vue?vue&type=template&id=294f41f6&scoped=true"
import script from "./payment-page-additional-travellers.vue?vue&type=script&setup=true&lang=ts"
export * from "./payment-page-additional-travellers.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./payment-page-additional-travellers.vue?vue&type=style&index=0&id=294f41f6&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294f41f6",
  null
  
)

export default component.exports